//axios拦截器
import axios from 'axios';
import { getToken } from './auth.js'
axios.defaults.timeout = 10000;
axios.defaults.withCredentials = true;
import router from './../router';

export default axios;
// http response 拦截器
axios.interceptors.response.use(
    response => {
        // 对象
        if (typeof response.data === 'object' && Object.prototype.toString.call(response.data) === '[object Object]') {
            // 后台返回的重新登录标识 不用这个了 都用后端的登录Session失效的判断
            // if (getToken() == '' && !sessionStorage.getItem("isLogin")) {
            //     router.replace("/");
            // }
            if (sessionStorage.getItem("isLogin")) {
                sessionStorage.setItem("isLogin", false);
            }
        }
        return response;
    },
    error => {
        console.log(error)
    });


// WEBPACK FOOTER //
// ./src/js/axios.js